<rid-button class="w-xs" [content]="content()" [disabled]="disabled()" (click)="clicked.emit()" />
